import {
  ColDef,
  ColGroupDef,
  ICellRendererParams,
  ValueFormatterParams,
} from "ag-grid-enterprise";
import { EditAndDeleteButtons } from "../../../../../../../shared/data-entries/EditAndDeleteButtons";
import { ManualAutoButton } from "../../../../../../../shared/data-entries/ManualAutoButton";
import { decimalMinutesToMmSs } from "@/utils/durationHelpers";

export type PlugType = "Inside Plug" | "Outside Plug";

type UsePlugMetricsTableDataProps = {
  onEdit: (plugType: PlugType) => void;
};

export type PlugMetricRow = {
  type: "Inside Plug" | "Outside Plug";
  Vol: number | null;
  Time: number | null;
  TotalTime: number | null;
  Heats: number | null;
  isManual?: boolean;
};

export const usePlugMetricsTableData = ({
  onEdit,
}: UsePlugMetricsTableDataProps) => {
  const columns: (ColDef | ColGroupDef)[] = [
    {
      headerName: "Plug Metrics",
      children: [
        {
          field: "manual-auto",
          headerName: " ",
          flex: 0.5,
          sortable: false,
          filter: false,
          cellRenderer: (params: ICellRendererParams<PlugMetricRow>) => {
            return (
              <ManualAutoButton isManual={params.data?.isManual ?? false} />
            );
          },
        },
        {
          headerName: "",
          field: "type",
          flex: 1,
          cellStyle: { fontWeight: "500" },
        },
        {
          field: "Vol",
          headerName: "Argon Vol",
          flex: 1,
          valueFormatter: (params: ValueFormatterParams) => {
            return params.value != null ? params.value.toFixed(2) : "0.00";
          },
        },
        {
          headerName: "Time",
          field: "Time",
          flex: 1,
          valueFormatter: (params: ValueFormatterParams) => {
            return params.value != null
              ? decimalMinutesToMmSs(params.value)
              : "00:00";
          },
        },
        {
          headerName: "Total Time",
          field: "TotalTime",
          flex: 1,
          valueFormatter: (params: ValueFormatterParams) => {
            return params.value != null ? params.value.toFixed(2) : "0.00";
          },
        },
        {
          field: "Heats",
          headerName: "Heats",
          flex: 1,
        },
        {
          headerName: "",
          field: "actions",
          cellRenderer: EditAndDeleteButtons,
          cellRendererParams: (params: ICellRendererParams<PlugMetricRow>) => ({
            deleteItem: undefined as any,
            onEdit: () => onEdit((params.data as PlugMetricRow).type),
            id: 0,
          }),
          flex: 0.5,
          minWidth: 80,
          sortable: false,
          filter: false,
        },
      ],
    },
  ];

  return { columns };
};
